import React, { useEffect, useState } from "react";
import { Checkbox, Col, Form, Input, Radio, Row, Table , Grid, Flex, Button, Space, Select, notification, message, GetProp, RadioChangeEvent, Modal, Card} from "antd";
import TextArea from "antd/es/input/TextArea";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AboutResearchInterface } from "../models/IAboutResearch";
import { oecdInterface } from "../models/Ioecd";
import { draftInterface } from "../models/IDraft";
import { SizeType } from "antd/es/config-provider/SizeContext";
import form, { FormProps } from "antd/es/form";
import { LeftOutlined } from "@ant-design/icons";
import moment from "moment";

const CheckboxGroup = Checkbox.Group;


const handleChange = (value: string) => {
    console.log(`selected ${value}`);
  };

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 11 }, (_, i) => currentYear - 5 + i+543);

export function BudgetreqAbout(){
    const [OtherOption,setOtherOption] = useState(false)
    const [newOECD,setnewOECD] = useState(false)


    const [success,setSuccess] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [sdgscheckedList, setSdgscheckedList] = useState<string[]>([]); // Initialize as an empty array
    const [responsecheckedList, setresponseheckedList] = useState<string[]>([]); // Initialize as an empty array
    const [oecd,setOECD] = useState<oecdInterface[]>([]);
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    const [destination,setDestination]=useState(``)
    const [respon,setrespon] = useState(``)
    const [CountryRes,setCountryRes] = useState(``)
    const [UniRes,setUniRes] = useState(``)
    const [CityRes,setCityRes] = useState(``)
    const [AgeRes,setAgeRes] = useState(``)
    const [other,setOther] = useState(``)
    const [BudgetType,setBudgetType] = useState('');

    const [TimesSent,setTimesSent] = useState(0)
    const [YearsSent,setYearsSent] = useState(moment().format('YYYY'))
    const [tmpoecd,settmpoecd] = useState(0);
    const [shownoecdtype,setshownoecdtype] = useState("");
    const [shownoecdsub,setshownoecdsub] = useState("");
    const [showField,setshowField] = useState("");
    const [selectedoecdtype,setselectedOECDtype] = useState("");
    const [selectedoecdsub,setselectedoecdsub] = useState("");
    const [selectedField,setselectedField] = useState(0);

    const [subOptions, setSubOptions] = useState<ItemProps[]>([]);
    const [fieldOptions, setFieldOptions] = useState<ItemProps[]>([]);
    const [showfield,setShowField] = useState(false)

    const location = useLocation();
    const navigate = useNavigate();
    const { project_id } = useParams();

    const [backmain,setmain] = useState(false);

    const TypeCheck = Form.useWatch('project_type',form)

    
    const handleCancel = ()=>{
      setmain(false)
    }
    const handleOECDTypeChange = (e: RadioChangeEvent) => {
      const value = e.target.value;
      setselectedOECDtype(value);
      setselectedoecdsub("");
      setFieldOptions([]);
  
      const selectedType = oecd.find(item => item.oecd_type === value);
      if (selectedType) {
          const subOptions = selectedType.subdata.map(sub => ({
              label: sub.oecd_sub_type,
              value: sub.oecd_sub_type,
          }));
          setSubOptions(subOptions);
      }
  };

  const handleOECDSubChange = (e: RadioChangeEvent) => {
    const value = e.target.value;
    setselectedoecdsub(value);
    console.log(value)
    const selectedType = oecd.find(item => item.oecd_type === selectedoecdtype);
    console.log(selectedType)
    if (selectedType) {
      
        const selectedSub = selectedType.subdata.find(sub => sub.oecd_sub_type === value);
        console.log(selectedSub)
        console.log(selectedSub?.Info)
        if (selectedSub && selectedSub.Info) {
          console.log(selectedSub.Info[0].oecd_field)
          if(!selectedSub.Info[0].oecd_field){
            setShowField(false);
            setselectedField((selectedSub.Info[0].oecd_id))
          }else{
            const Field = selectedSub.Info.map(field => ({
              label: field.oecd_field,
              value: String(field.oecd_id),
          }));
          console.log(Field)
          setFieldOptions(Field);
          setShowField(true);
          }
        } else {
            setFieldOptions([]); // Reset field options if `selectedSub` or `info` is undefined
            setShowField(false);
        }
    } else {
        setFieldOptions([]); // Reset field options if `selectedType` is undefined
        setShowField(false);
    }
  };

  const CheckSDGsonChange = (checkedValues: string[]) => {
    console.log('checked = ', checkedValues);
    setSdgscheckedList(checkedValues);
    console.log(sdgscheckedList);
};

const CheckResonChange = (checkedValues: string[]) => {
  console.log('checked = ', checkedValues);
  setresponseheckedList(checkedValues);
};
    
    // const CheckSDGsonChange = (list: string[]) => {
    //     console.log('checked = ', checkedValues);
    //     setCheckedList(list);
    //     console.log(list)
    //   };
      

    const OECDhandleChange = (value: string) => {
        console.log(`selected ${value}`);
        setselectedOECDtype(value)
      };

      
    const handleMainInfo = () =>{
      setDestination(`/VRIIS/BudgetReqInfo/${project_id}`)
        
        
    }
    const handleNextPart = () =>{
        setDestination(`/VRIIS/BudgetReqResearcher/${project_id}`)
    }
      
    const getProjectPreview = async()=>{
        axios.get(`${process.env.REACT_APP_BASE}/BudgetReqInfo/${project_id}/${sessionStorage.getItem('user')}`).then(response =>{
          console.log(project_id)
          console.log(response.data.main[0])

          form.setFieldsValue({
            project_name_en: response.data.main[0].project_name_en,
            project_name_th: response.data.main[0].project_name_th,
            BudgetType : response.data.main[0].budget_type,
            project_type: response.data.main[0].project_type,
            sdgs: JSON.parse(response.data.main[0].sdgs),
            project_place : response.data.main[0].project_place,
            other_project_type : response.data.main[0].other_project_type
          });
          
          setTimesSent(response.data.main[0].TimesSent)
          setYearsSent(response.data.main[0].YearsSent)

          setSdgscheckedList(JSON.parse(response.data.main[0].sdgs))
          setBudgetType(response.data.main[0].budget_type)
          setshownoecdtype(response.data.main[0].oecd_type)
          setshownoecdsub(response.data.main[0].oecd_sub_type)
          setshowField(response.data.main[0].oecd_field)
          setselectedField(response.data.main[0].oecd_id)
          settmpoecd(response.data.main[0].oecd_id)
          
          
          if(response.data.main[0].response){
            console.log('here')
          let tmp = JSON.parse(response.data.main[0].response || '[]')
          console.log(tmp)
          setresponseheckedList(tmp.selectedchoice)
          setrespon(tmp.selectedchoice)
          if('other' in tmp&&tmp.other!=''){
            setOtherOption(true)
            setOther(tmp.other)
          }
          if('country' in tmp&&tmp.country!=''){
            setOtherOption(true)
            setCountryRes(tmp.country)
          }
          if('uni' in tmp&&tmp.uni!=''){
            setOtherOption(true)
            setUniRes(tmp.uni)
          }if('city' in tmp&&tmp.city!=''){
            setOtherOption(true)
            setCityRes(tmp.city)
          }
          if('age' in tmp&&tmp.age!=''){
            setOtherOption(true)
            setAgeRes(tmp.age)
          }
          
          form.setFieldsValue({
            response: tmp.selectedchoice
          })
        }
          
          console.log(form.getFieldsValue())
        })
      }

      interface ItemProps {
        label: string;
        value: string;
      }
      const options: ItemProps[] = [];

      for (let i = 0; i < oecd.length; i++) {
        const value = oecd[i].oecd_type
        options.push({
          label: oecd[i].oecd_type,
          value,
        });
      }

      const getOECD = async()=>{
        axios.get(`${process.env.REACT_APP_BASE}/oecd`).then(response => {
            console.log(response.data)
            setOECD(response.data)
        }).catch(error =>{console.log(error)})
    }
      useEffect(()=>{
        getProjectPreview();
        getOECD();
      },[])

      const handleFinish : FormProps<AboutResearchInterface>['onFinish'] = (values) => {
        console.log(values)
        console.log(Number(sessionStorage.getItem("user")))
        console.log('กำลังกดบันทึก')
        try{
          if(Array.isArray(responsecheckedList) && responsecheckedList?.includes("อื่นๆ")){
            if(other==``){
              setErrorMessage("ช่อง 'อื่นๆ' ไม่สามารถปล่อยว่างได้")
              throw new Error("ช่อง 'อื่นๆ' ไม่สามารถปล่อยว่างได้")
            }
          }
          let tmp = {
          selectedchoice : responsecheckedList,
          country : CountryRes,
          uni : UniRes,
          city : CityRes,
          age : AgeRes,
          other : other,
          }
        
        const data = {
            part:'part1',
            project_name_th: values.project_name_th,
            project_name_en: values.project_name_en,
            project_type: values.project_type,
            oecd_id : selectedField,
            budget_type : BudgetType,
            sdgs : JSON.stringify(sdgscheckedList),
            responsibility : JSON.stringify(tmp),
            project_place : values.project_place,
            TimesSent:TimesSent,
            YearsSent:YearsSent
          }
          console.log(data)
          
        // return data
        axios 
        .patch(`${process.env.REACT_APP_BASE}/UpdateBudgetReq/${project_id}`, data)
        .then((response) => {
          if (response.status === 200) {
            console.log("บันทึกสำเร็จ")
            setSuccess(true);
            console.log(response);
            setSuccess(true);
            navigate(destination)
            notification.success({
              message:'บันทึกสำเร็จ'
            })
          }
        })
        .catch((error) => {
            setError(true);
            console.log(error)
            console.log(error.response)
            notification.error({
                message: "บันทึกข้อมูลไม่สำเร็จ",
                description: error.response.data.Message,
              });
            setErrorMessage(error.response.data.Message)
        });}catch (error) {
          if (error instanceof Error) {
              // Handle error with a notification using the error message
              notification.error({
                  message: "พบข้อผิดพลาด",  // General error heading
                  description: error.message,  // Use the thrown error message
              });
          } else {
              // Handle non-Error type (just in case)
              notification.error({
                  message: "พบข้อผิดพลาด",
                  description: "เกิดข้อผิดพลาดบางอย่าง",
              });
          }
      }
    }

  const handleShowOecd = () => {
    console.log('click')
    if(!newOECD){
      setselectedField(0);
      setnewOECD(true)
    }else{
      setselectedField(tmpoecd);
      setnewOECD(false) 
    }
  }

    return(
      <>
      
      
        <div
        style={{
          padding:30
        }}
        >
          <h1 className="text-3xl font-semibold ">แบบฟอร์มเสนอโครงการงานวิจัยและนวัตกรรม</h1>
        <p>เพื่อขอรับเงินทุนสนับสนุนงานวิจัยและนวัตกรรมจากมหาวิทยาลัยวงษ์ชวลิตกุล</p>
        <br /><hr /><br />
        {contextHolder}
            <h2 className="text-3xl font-bold ">ส่วนที่ 1 ข้อมูลงานวิจัย</h2>
            <hr/><br />
        
            <Form  wrapperCol={{ span: 50 }}
            layout="vertical"
            onFinish={handleFinish}
            autoComplete="off"
            form={form}
            size={componentSize as SizeType}
            >

                <Form.Item name={['project_name_th']} className="font-semibold" 
                rules={[{ required: true, 
                  message: 'ชื่อโครงการวิจัยของท่านไม่สามารถปล่อยว่างได้',
                  },]}
                  label={`ชื่อโครงการวิจัยภาษาไทย`} layout="vertical">
                    <TextArea className="font-normal" autoSize />
                </Form.Item>
           
                <Form.Item name={['project_name_en']} className="font-semibold"
                rules={[{ required: true, 
                  message: 'ชื่อโครงการวิจัยของท่านไม่สามารถปล่อยว่างได้'},
                  {
                  pattern: /^[a-zA-Z0-9\s!@#$%^&*()_+={}:;"'<>,.?\/`~\-’]*$/ ,
                  message: 'ชื่อโครงการของท่านที่กรอกในช่องนี้ ต้องเป็นตัวอักษรภาษาอังกฤษ ตัวเลข และสัญลักษณ์เท่านั้น'
                  }]}
                label={`ชื่อโครงการวิจัยภาษาอังกฤษ`} layout="vertical">
                    <TextArea className="font-normal" autoSize />
                </Form.Item>
                <Form.Item label='ครั้งที่ยื่นขอทุน' className='font-semibold' layout="vertical">
            <p style={{ marginLeft: '40px', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
              ครั้งที่&nbsp;
              <Select
              value={TimesSent}
              onChange={(value)=>setTimesSent(value)}
              style={{width:'10vw'}}
                options={[
                  { label: '1', value: 1 },
                  { label: '2', value: 2 },
                  { label: '3', value: 3 },
                  { label: '4', value: 4 },
                  { label: '5', value: 5 },
                ]}
              />
              /<Select
                value={YearsSent}
                onChange={(value)=>setYearsSent(value)}
                style={{ width: 120 }}
                options={years.map((year) => ({
                  label: year.toString(),
                  value: year.toString(),
                }))}
              />
            </p>
            </Form.Item>
            <Card style={{backgroundColor:'beige'}}>
              <Card style={{backgroundColor:'white'}}>
                <p>หากเปลี่ยนประเภททุนและกดบันทึก จำนวนทุนและผู้ร่วมวิจัยที่ท่านเคยกรอกจะหายไปทั้งหมด กรุณาตรวจสอบก่อนกดบันทึก</p>
              </Card>
            </Card>
            <Form.Item className="font-semibold"
            rules={[{ required: true}]} label='ประเภททุน'>
              <Radio.Group className="font-normal" value={BudgetType} onChange={e => setBudgetType(e.target.value)}>
                  <Radio value="ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา">ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา</Radio>
                  <Radio value="ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร">ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item style={{ maxWidth: 600 }} className="font-semibold" name={['project_type']} label='ประเภทโครงการวิจัย ' layout="horizontal">
                <Select
                defaultValue={'กรุณาเลือกประเภทของงานวิจัย'}
                onChange={handleChange}
                options={[
                    { value: 1, label: 'งานวิจัยเชิงวัฒนธรรม' },
                    { value: 2, label: 'งานนวัตกรรม' },
                    { value: 3, label: 'งานวิจัยเพื่อสร้างองค์ประกอบความรู้พื้นฐาน' },
                    { value: 4, label: 'งานวิจัยเชิงประยุกต์' },
                    { value: 5, label: 'งานสร้างสรรค์(หนังสั้น สารคดี โฆษณา)' },
                    { value: 6, label: 'งานวิจัยประเมินหลักสูตร' },
                    { value: 7, label: 'อื่นๆ' },

                ]}
                />
            </Form.Item>
            {TypeCheck==7&&
              <Form.Item style={{marginLeft:'40px',maxWidth: 800 }} className='font-semibold' name={['other_project_type']} label='โปรดระบุ' layout='horizontal'>
                <Input className="font-normal" />
              </Form.Item>}
            <br/>
            <hr/>
            <br/>
              <p className="font-semibold">สาขาวิชาที่ทำการวิจัยจำแนกตาม OECD ของโครงการนี้คือ </p>
              <p style={{marginLeft:40}}>{shownoecdtype} ( {shownoecdsub} {showField!=null && <>,( {showField} )</>} ) 
              </p>
              <br/>
              <p style={{marginLeft:40}}></p>
              <p>ต้องการเปลี่ยนสาขา? {!newOECD && <Button onClick={handleShowOecd}>เปลี่ยนสาขา</Button> || <Button onClick={handleShowOecd}>ไม่ต้องการเปลี่ยนสาขาแล้ว</Button>}</p>
              <br/>
              {newOECD &&<><Form.Item label='โปรดเลือกสาขาวิชาที่ทำการวิจัยจำแนกตามOECD' rules={[{ required: true, message: 'กรุณาเลือก OECDของท่าน หรือกดปุ่ม ไม่ต้องการเปลี่ยนสาขาแล้ว'}]} >
                    <Space direction="vertical">
                    <Radio.Group onChange={handleOECDTypeChange} value={selectedoecdtype}>
                    <Space direction="vertical">
                      {oecd.map((item) => (
                        <React.Fragment key={item.oecd_type}>
                        <Space direction="vertical">
                        <Radio value={item.oecd_type}>{item.oecd_type}</Radio>
                        {(selectedoecdtype == item.oecd_type) && (
                          <Radio.Group style={{ marginLeft: '20px' }} onChange={handleOECDSubChange} value={selectedoecdsub}>
                          <Space direction="vertical" style={{ marginLeft: '20px' }}>
                              {subOptions.map((subitem) => (
                                <><Radio value={subitem.value} key={subitem.value}>
                                  {subitem.label}
                                </Radio>
                                {(showfield) && (<>
                                {
                                  selectedoecdsub === subitem.label && (
                                    <Form.Item>
                                    <Radio.Group onChange={(e) => setselectedField(e.target.value)} value={selectedField} style={{ marginLeft: '40px' }}> 
                                    <Space direction="vertical">
                                    {fieldOptions.map((field) => (
                                        <Radio key={field.value} value={field.value}>
                                        {field.label}
                                      </Radio>
                                    ))}
                                    </Space>
                                    </Radio.Group>
                                    </Form.Item>
                                  )
                                }
                                    </>
                                )}
                                </>
                              ))}
                              </Space>
                            </Radio.Group>)}
                          </Space>
                          </React.Fragment>
                          ))}
                            </Space>
                        </Radio.Group>
                    </Space>
              </Form.Item>
              </>}
              <br/>
              <hr/>
              <br/>
                    <Form.Item rules={[{ required: true ,message: 'กรุณาเลือก SDGs ของท่านก่อนกดบันทึกข้อมูล'}]} 
                    name={['sdgs']} 
                    className="font-semibold" 
                    label='งานวิจัยมีความสอดคล้องกับ The 17 sustainable development goals (SDGs) ใด (เลือกได้มากกว่า 1 ข้อ)' 
                    layout="vertical">
                        <Checkbox.Group onChange={CheckSDGsonChange} className="font-normal " >
                          <Row>
                            <Col span={10}>
                            <Checkbox value="GOAL 1: No Poverty">GOAL 1: No Poverty</Checkbox></Col>
                            <Col span={10}>
                            <Checkbox value="GOAL 2: Zero Hunger">GOAL 2: Zero Hunger</Checkbox>
                            </Col>
                            <Col span={10}>
                            <Checkbox value="GOAL 3: Good Health and Well-being">GOAL 3: Good Health and Well-being</Checkbox>
                            </Col>
                            <Col span={10}>
                            <Checkbox value="GOAL 4: Quality Education">GOAL 4: Quality Education</Checkbox>
                            </Col>
                            <Col span={10}>
                            <Checkbox value="GOAL 5: Gender Equality">GOAL 5: Gender Equality</Checkbox>
                           </Col>
                            <Col span={10}>
                            <Checkbox value="GOAL 6: Clean Water and Sanitation">GOAL 6: Clean Water and Sanitation</Checkbox>
                            </Col>
                            <Col span={10}>
                            <Checkbox value="GOAL 7: Affordable and Clean Energy">GOAL 7: Affordable and Clean Energy</Checkbox></Col>
                            <Col span={10}>
                            <Checkbox value="GOAL 8: Decent Work and Economic Growth">GOAL 8: Decent Work and Economic Growth</Checkbox></Col>
                            <Col span={10}><Checkbox value="GOAL 9: Industry, Innovation and Infrastructure">GOAL 9: Industry, Innovation and Infrastructure</Checkbox>
                            </Col>
                            <Col span={10}>
                            <Checkbox value="GOAL 10: Reduced Inequality">GOAL 10: Reduced Inequality</Checkbox></Col>
                            <Col span={10}>
                            <Checkbox value="GOAL 11: Sustainable Cities and Communities">GOAL 11: Sustainable Cities and Communities</Checkbox></Col>
                            <Col span={10}>
                            <Checkbox value="GOAL 12: Responsible Consumption and Production">GOAL 12: Responsible Consumption and Production</Checkbox></Col>
                            <Col span={10}>
                            <Checkbox value="GOAL 13: Climate Action">GOAL 13: Climate Action</Checkbox></Col>
                            <Col span={10}>
                            <Checkbox value="GOAL 14: Life Below Water">GOAL 14: Life Below Water</Checkbox>
                            </Col>
                            <Col span={10}>
                            <Checkbox value="GOAL 15: Life on Land">GOAL 15: Life on Land</Checkbox>
                            </Col>
                            <Col span={10}>
                            <Checkbox value="GOAL 16: Peace and Justice Strong Institutions">GOAL 16: Peace and Justice Strong Institutions</Checkbox></Col>
                            <Col span={10}><Checkbox value="GOAL 17: Strengthening global partnerships">GOAL 17: Strengthening global partnerships</Checkbox></Col>
                        </Row>
                        </Checkbox.Group>
                    </Form.Item>
                    <br/>
                    <hr/>
                    <br/>
                    <Form.Item 
                    rules={[{ required: true,message:'กรุณาเลือกข้อมูลอย่างน้อย1ข้อก่อนกดบันทึกหรือเปลี่ยนหน้า'}]} 
                      name={['response']} 
                      className='font-semibold' 
                      label='การตอบสนองต่อความต้องการของประเทศและชุมชนพื้นที่' 
                      layout="vertical"
                    >
                      <Checkbox.Group onChange={CheckResonChange} className='font-normal'>
                        <Row>
                          <Col span={24}>
                            <Checkbox value="ตอบสนองต่อยุทธศาสตร์ชาติ"> ตอบสนองต่อยุทธศาสตร์ชาติ </Checkbox>
                          </Col>
                          {
                            responsecheckedList.includes("ตอบสนองต่อยุทธศาสตร์ชาติ")&&
                            <>
                              <TextArea
                              value={CountryRes} 
                              onChange={(e) => setCountryRes(e.target.value)} 
                              autoSize/>
                            </>
                          }

                          <Col span={24}>
                            <Checkbox value="ตอบสนองต่อยุทธศาสตร์ของมหาวิทยาลัยวงษ์ชวลิตกุล"> ตอบสนองต่อยุทธศาสตร์ของมหาวิทยาลัยวงษ์ชวลิตกุล </Checkbox>
                          </Col>
                          {
                            responsecheckedList.includes("ตอบสนองต่อยุทธศาสตร์ของมหาวิทยาลัยวงษ์ชวลิตกุล")&&
                            <>
                              <TextArea 
                              value={UniRes} 
                              onChange={(e) => setUniRes(e.target.value)} 
                              autoSize/>
                            </>
                          }

                          <Col span={24}>
                            <Checkbox value="ตอบสนองต่อความต้องการของชุมชนพื้นที่"> ตอบสนองต่อความต้องการของชุมชนพื้นที่ </Checkbox>
                          </Col>
                          {
                            responsecheckedList.includes("ตอบสนองต่อความต้องการของชุมชนพื้นที่")&&
                            <>
                              <TextArea 
                              value={CityRes} 
                              onChange={(e) => setCityRes(e.target.value)} 
                              autoSize/>
                            </>
                          }

                          <Col span={24}>
                            <Checkbox value="ตอบสนองต่อการเรียนรู้ตลอดชีวิต / สังคมผู้สูงอายุ"> ตอบสนองต่อการเรียนรู้ตลอดชีวิต / สังคมผู้สูงอายุ </Checkbox>
                          </Col>
                          {
                            responsecheckedList.includes("ตอบสนองต่อการเรียนรู้ตลอดชีวิต / สังคมผู้สูงอายุ")&&
                            <>
                              <TextArea 
                              value={AgeRes} 
                              onChange={(e) => setAgeRes(e.target.value)} 
                              autoSize/>
                            </>
                          }

                          <Col span={24}>
                            <Checkbox 
                              value="อื่นๆ" 
                              onChange={(e) => {
                                setOtherOption(e.target.checked); 
                                if (!e.target.checked) {
                                  console.log(`uncheck`)
                                  setOther(``);
                                }
                              }}
                            >
                              อื่นๆ
                            </Checkbox>
                            {OtherOption && (
                              <Form.Item layout="vertical" >
                                <Input 
                                  value={other} 
                                  onChange={(e) => setOther(e.target.value)} 
                                />
                              </Form.Item>
                            )}
                          </Col>
                        </Row>
                      </Checkbox.Group>
                    </Form.Item>

                <hr /><br />
                
                
            
            <br/>
            <Form.Item className='font-semibold' rules={[{required:true,message:'กรุณากรอกข้อมูลสถานที่ทำการทดลอง และ/หรือ เก็บข้อมูลก่อนกดบันทึก'}]} label='สถานที่ทำการทดลอง และ/หรือ เก็บข้อมูล' name={['project_place']}>
              <Input className='font-normal'/>
            </Form.Item>
            <Flex justify="center"><Button type="primary"  htmlType='submit' 
              style={{
                backgroundColor: '#33b249',
                color: 'white',
                borderColor: '#33b249',
              }}>บันทึก</Button></Flex>
            <br/>
            <Flex justify="space-between" align="center" style={{ width: '100%' }}>
              <div style={{ flex: 1, textAlign: 'left' }}>
                <Button onClick={()=>setmain(true)} type="primary">
                  กลับหน้าหลัก
                </Button>
              </div>
              <Modal
              title="ยืนยันการกลับหน้าหลัก"
              width={'50vw'}
              open={backmain}
              onCancel={handleCancel}
              footer={[
                <><Button key="back" onClick={handleCancel}>
                  ยกเลิก
                </Button>
                <Button  key="go" danger type="primary" href={`/VRIIS/BudgetReqInfo/${project_id}`}>
                  ตกลง
                </Button>
                </>
              ]}
              >
                การตกลงจะนำทางท่านไปสู่หน้าจอแสดงข้อมูลหลักโดยไม่บันทึกข้อมูลที่ท่านกรอกไปแล้ว ท่านมั่นใจหรือไม่ที่จะกลับไปหน้าหลัก
              </Modal>
              <div style={{ flex: 1, textAlign: 'center' }}>
                <Button type="primary" htmlType="submit" onClick={handleMainInfo}>
                  บันทึกแล้วกลับหน้าแสดงข้อมูล
                </Button>
              </div>
              <div style={{ flex: 1, textAlign: 'right' }}>
                <Button
                  type="primary"
                  style={{
                    backgroundColor: '#33b249',
                    color: 'white',
                    borderColor: '#33b249',
                  }}
                  htmlType="submit"
                  onClick={handleNextPart}
                >
                  บันทึกแล้วไปส่วนที่ 2
                </Button>
              </div>
            </Flex>
            </Form>
            </div></>
    )
}